export enum PreDesignReviewState {
    Submitted = "Submitted",
    EditsRequired = "EditsRequired",
    Approved = "Approved",
    Rejected = "Rejected",
}
